var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12L17.5 10L18.5 4H3.5M5.5 12L3.5 4M5.5 12V14H17.5M3.5 4L2.5 1H0.5M6.5 17.5C6.5 18.329 5.829 19 5 19C4.171 19 3.5 18.329 3.5 17.5C3.5 16.671 4.171 16 5 16C5.829 16 6.5 16.671 6.5 17.5ZM18.5 17.5C18.5 18.329 17.829 19 17 19C16.171 19 15.5 18.329 15.5 17.5C15.5 16.671 16.171 16 17 16C17.829 16 18.5 16.671 18.5 17.5Z",
    stroke: "#646D7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersIcon);
export default __webpack_public_path__ + "static/media/customers-icon.702ff9774e001cdf0b2c9b8ddd246919.svg";
export { ForwardRef as ReactComponent };